// The HUD's casino sounds: chip clicks, coins, the crate, the reels and the jackpot fanfare.
import { audioCtx, hiss, tone } from "./ctx";

let out;
const bus = () => {
  if (!out) {
    const c = audioCtx();
    out = c.createGain();
    out.gain.value = 0.7;
    out.connect(c.destination);
  }
  return out;
};

const coin = (o, t, pitch = 1) => [2637, 3951].forEach((f) => tone(o, { freq: f * pitch, t, peak: 0.05, attack: 0.002, end: 0.25 }));
const notes = (o, t, fs, gap, type = "square", peak = 0.04) =>
  fs.forEach((f, i) => tone(o, { type, freq: f, t: t + i * gap, peak, end: gap * 1.6 }));

const SOUNDS = {
  click: (o, t) => tone(o, { type: "triangle", freq: 1400, to: 900, t, peak: 0.05, end: 0.04 }),
  coin: (o, t) => coin(o, t),
  collect: (o, t) => {
    for (let i = 0; i < 6; i++) coin(o, t + i * 0.06, 1 + i * 0.04);
    notes(o, t + 0.3, [784, 988, 1175], 0.07, "triangle", 0.05);
  },
  ready: (o, t) => notes(o, t, [988, 1319], 0.12, "sine", 0.06),
  notice: (o, t) => notes(o, t, [1175, 1568], 0.08, "sine", 0.04),
  trade: (o, t) => {
    for (let i = 0; i < 5; i++) hiss(o, { t: t + i * 0.07, freq: 500 + i * 120, q: 4, peak: 0.12, end: 0.06 });
    hiss(o, { t: t + 0.4, freq: 2500, q: 0.7, peak: 0.15, end: 0.18 });
    coin(o, t + 0.45);
  },
  reel: (o, t) => {
    for (let i = 0; i < 18; i++) tone(o, { type: "square", freq: 1800, t: t + i * 0.05 + i * i * 0.002, peak: 0.015, end: 0.02 });
  },
  win: (o, t) => {
    notes(o, t, [523, 659, 784, 1047], 0.09);
    for (let i = 0; i < 8; i++) coin(o, t + 0.36 + i * 0.05, 1 + (i % 3) * 0.06);
  },
  jackpot: (o, t) => {
    notes(o, t, [523, 659, 784, 1047, 784, 1047, 1319, 1568], 0.08, "square", 0.05);
    for (let i = 0; i < 20; i++) coin(o, t + 0.5 + i * 0.045, 0.9 + Math.random() * 0.3);
  },
  lose: (o, t) => notes(o, t, [392, 311], 0.18, "triangle", 0.05),
};

export function play(kind) {
  const o = bus();
  (SOUNDS[kind] || SOUNDS.click)(o, o.context.currentTime + 0.01);
}
